(function () {
  'use strict';
  const rows = window.OURO_CATALOG || [];
  const config = window.OURO_COMMERCE_SETTINGS || {};
  const root = typeof config.root === 'string' && /^\/(?!\/)[\w/-]*$/.test(config.root) ? config.root.replace(/\/?$/, '/') : '/';
  const records = new Map(rows.map(row => [row.key, row]));
  const seen = new Set();
  let adding = false;
  function url(suffix) { return root + suffix; }
  async function json(suffix, options) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url(suffix), Object.assign({credentials:'same-origin', cache:'no-store', signal:controller.signal}, options));
      if (!response.ok) throw new Error('http-' + response.status);
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  async function product(row) {
    const p = await json('products/' + row.handle + '.js');
    if (String(p.id) !== row.productId || p.handle !== row.handle || !Array.isArray(p.variants) || p.variants.length !== 1) throw new Error('mapping');
    const v = p.variants[0];
    if (!Number.isSafeInteger(v.id) || v.id <= 0 || !Number.isSafeInteger(v.price) || v.price <= 0) throw new Error('variant');
    return v;
  }
  function reply(frame, request, data) {
    frame.contentWindow.postMessage(Object.assign({type:'ouro-commerce-result', requestId:request.requestId, key:request.key, action:request.action}, data), '*');
  }
  window.addEventListener('message', async function (event) {
    const frame = document.querySelector('#OuroLabDialog .ouro-lab-frame iframe');
    const request = event.data;
    if (!frame || event.source !== frame.contentWindow || !request || request.type !== 'ouro-commerce-request') return;
    if (!/^[a-z0-9-]{1,80}$/i.test(request.requestId || '')) return;
    if (request.action === 'cart') {
      // Destination is fixed by the host, never supplied by the embedded document.
      window.location.assign(url('cart')); return;
    }
    const row = records.get(request.key);
    if (!row || !['quote','add'].includes(request.action)) return;
    if (!config.enabled) { reply(frame, request, {status:'draft', price:row.price}); return; }
    if (config.currency !== 'MXN') { reply(frame, request, {status:'error', message:'Consulta esta presentación en la tienda para ver su moneda y precio.'}); return; }
    if (request.action === 'quote') {
      try {
        const v = await product(row);
        reply(frame, request, {status:v.available ? 'available' : 'sold-out', price:v.price});
      } catch (_) { reply(frame, request, {status:'error', message:'No podemos confirmar esta presentación. Inténtalo de nuevo más tarde.'}); }
      return;
    }
    if (adding || seen.has(request.requestId)) return;
    if (!Number.isInteger(request.quantity) || request.quantity < 1 || request.quantity > 200) {
      reply(frame, request, {status:'error', message:'Elige una cantidad entre 1 y 200.'}); return;
    }
    adding = true;
    seen.add(request.requestId);
    if (seen.size > 200) seen.delete(seen.values().next().value);
    let submitted = false;
    try {
      const v = await product(row);
      if (!v.available) { reply(frame, request, {status:'sold-out', price:v.price}); return; }
      if (v.price !== request.price) { reply(frame, request, {status:'changed', price:v.price, message:'El precio cambió. Revísalo antes de agregar.'}); return; }
      const cart = await json('cart.js');
      if (cart.currency !== 'MXN') throw new Error('currency');
      submitted = true;
      const result = await json('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:v.id, quantity:request.quantity}]})});
      if (!result.items?.some(item => String(item.variant_id || item.id) === String(v.id))) throw new Error('unconfirmed');
      reply(frame, request, {status:'added', message:row.name + ' agregado al carrito.'});
      document.dispatchEvent(new CustomEvent('ouro:cart-updated'));
      // Cart is confirmed independently of this cosmetic counter update.
      json('cart.js').then(cart => {
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
      }).catch(() => {});
    } catch (_) {
      reply(frame, request, submitted
        ? {status:'uncertain', message:'No pudimos confirmar el resultado. Revisa tu carrito antes de volver a agregar; no hemos repetido el envío.'}
        : {status:'error', message:'No pudimos comprobar precio o disponibilidad. No se envió ningún producto al carrito.'});
    } finally { adding = false; }
  });
  document.querySelectorAll('[data-commerce-native]').forEach(container => {
    const current = rows.find(row => row.handle === container.dataset.commerceNative);
    if (!current || !current.family) return;
    const siblings = rows.filter(row => row.family === current.family);
    if (siblings.length < 2) return;
    const label = document.createElement('p'); label.textContent = 'Elige tu presentación'; container.appendChild(label);
    const nav = document.createElement('nav'); nav.setAttribute('aria-label', 'Presentaciones de este producto');
    siblings.forEach(row => {
      const a = document.createElement('a');
      const destination = new URL(url('products/' + row.handle), window.location.origin);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
      a.href = destination.pathname + destination.search; a.textContent = row.presentation;
      if (row.key === current.key) a.setAttribute('aria-current','page');
      nav.appendChild(a);
    });
    container.appendChild(nav);
  });
})();
